<template>
    <div class="change-pwd">
        <h3 class="change-pwd__title">
            <label class="label">安全设置</label>
            <span class="description">
                请尽早完善账户安全信息，更好地保护您的数据安全！如遇到问题请添加小编微信：shuzixs01
            </span>
        </h3>
        <div class="change-pwd__content">
            <div class="change-pwd__content-item">
                <div class="content-item__title">
                    <label class="label">登录密码:</label>
                    <span class="description">
                        密码要求至少包含字母，符号或数字中的两项且长度超过8位，建议您经常修改密码，以保证帐号更加安全。
                    </span>
                    <el-button type="primary" class="change-pwd__button" @click="openDialog('visible')">
                        修改
                    </el-button>
                </div>
            </div>
        </div>
        <div class="change-pwd__content" v-if="userInfo.email && userInfo.email!=null">
            <div class="change-pwd__content-item">
                <div class="content-item__title">
                    <label class="label">绑定邮箱:</label>
                    <span class="description">
                        已绑定邮箱：{{userInfo.email}}
                    </span>
                    <el-button class="change-pwd__button wx-button" @click="closeEmailconfirm">
                        解绑
                    </el-button>
                </div>
            </div>
        </div>
        <div class="change-pwd__content"  v-else>
            <div class="change-pwd__content-item">
                <div class="content-item__title">
                    <label class="label">绑定邮箱:</label>
                    <span class="description">
                        点击绑定国内邮箱，绑定邮箱后可使用邮箱和密码登录。
                    </span>
                    <el-button type="primary" class="change-pwd__button" @click="openDialog('emialVisible')">
                        绑定
                    </el-button>
                </div>
            </div>
        </div>
        <div class="change-pwd__content" v-if="userInfo.openid && userInfo.openid!=null">
            <div class="change-pwd__content-item">
                <div class="content-item__title">
                    <label class="label">微信账号绑定:</label>
                    <span class="description">
                        已绑定微信：{{userInfo.wxname}}
                    </span>
                    <el-button class="change-pwd__button wx-button" @click="closeWxconfirm">
                        解绑
                    </el-button>
                </div>
            </div>
        </div>
        <div class="change-pwd__content" v-else="">
            <div class="change-pwd__content-item">
                <div class="content-item__title">
                    <label class="label">微信账号绑定:</label>
                    <span class="description">
                        绑定第三方账户有利于您快速登录，和账号丢失时快速找回
                    </span>
                    <el-button type="primary" class="change-pwd__button" @click="wxLogin">
                        绑定
                    </el-button>
                </div>
            </div>
        </div>

        <transition name="dialogFade">
            <change-pwd-dialog v-if="visible" @closeDialog="closeDialog"></change-pwd-dialog>
            <bind-email-dialog v-if="emialVisible" @closeDialog="closeDialog"></bind-email-dialog>
        </transition>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ChangePwdDialog from './ChangePwdDialog';
import BindEmailDialog from './BindEmailDialog';
import { wxUnbound } from '@/api/login';

export default {
    name: 'ChangePwd',
    components: {
        ChangePwdDialog,
        BindEmailDialog
    },
    data: () => ({
        visible: false,
        emialVisible: false
    }),
    computed: {
        ...mapState('user', ['userInfo'])
    },
    methods: {
        closeDialog() {
            this.visible = false;
            this.emialVisible = false
        },
        openDialog(type) {
            this[type] = true;
        },
        closeWxconfirm() {
            this.$confirm('解除微信账号绑定将无法扫码登录, 是否继续?', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                wxUnbound({
                    type: 0
                }).then((res)=>{
                    if(res.code === 0){
                        this.$message.success('微信解绑成功');
                        this.$store.dispatch('user/getUserInfo');
                    }
                })
            }).catch(() => {});
        },
        closeEmailconfirm() {
            this.$confirm('确认解除绑定？', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                wxUnbound({
                    type: 1
                }).then((res)=>{
                    if(res.code === 0){
                        this.$message.success('邮箱解绑成功');
                        this.$store.dispatch('user/getUserInfo');
                    }
                })
            }).catch(() => {});
        },
        wxLogin() {
            localStorage.setItem('path', this.$route.path);
            var url = window.location.protocol+"//"+window.location.host;
            window.location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=wxc78ed9988e859851&redirect_uri=${url}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`;
        }
    }
};
</script>

<style lang="scss" scoped>
.change-pwd {
    &__content{
        margin-bottom: 50px;
    }
    &__button {
        width: 110px;
        height: 40px;
        @include font(rgba(255, 255, 255, 1), 16px, 400);
    }
    .wx-button{
        color: #2C54EF;
        border: 1px solid #2C54EF;
    }

    .label {
        @include font(rgba(39, 44, 64, 1), 16px, 600);
    }
    .description {
        @include font(rgba(145, 145, 145, 1), 14px, 400);
    }

    &__title {
        margin-bottom: 20px;
        .label {
            margin-right: 10px;
            @include font(rgba(39, 44, 64, 1), 24px, 600);
        }
        .description {
            @include font(rgba(145, 145, 145, 1), 14px, 400);
        }
    }

    .content-item {
        display: flex;
        align-items: center;
        @include font(rgba(39, 44, 64, 1), 16px, 600);

        &:not(:first-child) {
            margin-top: 30px;
        }

        &__title {
            display: flex;
            .label {
                width: 110px;
            }
            .description {
                width: 430px;
                margin-right: 30px;
            }
        }
    }
}
.dialogFade-enter-active,
.dialogFade-leave-active {
    transition: opacity 0.4s;
}

.dialogFade-enter,
.dialogFade-leave-active {
    opacity: 0;
}
</style>
